import React from 'react';
import { Button, Col, DropdownButton, Input, MenuItem, Panel, Row } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Selection } from '../Common/selection';
import { connect } from 'react-redux';
import { fetchBaseUsers } from '../../actions/settings_actions';
import genericRadioFilter from '../Common/genericRadioFilter';
import GenericDatePicker from '../Common/GenericDatePicker';
import GenericSelection from '../Common/GenericSelection';
import CustomerStatement from './customerStatement';
import moment from 'moment';
import ReactDataGrid from 'react-data-grid';
import checkPermission from '../Common/permissions';
import { getFromToDates, toFromDates } from '../Common/cleanDates';
import { AR_REPORT_CUSTOMERS_URL } from '../../actions/url';
import axios from 'axios';
import { DEFAULT_ERROR } from '../Common/constants';
import { printARReportBySales, printPlainARReportBySales } from '../../actions/print_actions';
class PrintBySalesModal extends React.Component {
  constructor() {
    super();
    this.state = {
      salesId: '',
      typeRadios: 'range',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: CustomerStatement.getQuarter(),
      fromDate: new Date('2017-08-18T00:00:00-0700'),
      toDate: new Date(),
      state: '',
      customerName: '',
      paymentCutoffDate: new Date(),
      customers: [],
      sortColumn: 'State',
      sortDirection: 'ASC',
    }
  }

  componentDidMount() {
    this.props.fetchBaseUsers();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.Seller) {
      if (nextProps.Seller.value !== this.state.salesId) {
        this.setState({
          salesId: nextProps.Seller.value
        });
      }
    } else {
      this.setState({
        salesId: ''
      });
    }
  }

  getUsers = () => {
    let Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  handleDateFilterChange = type => {
    if (type === 'month') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
    } else if (type === 'quarter') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: CustomerStatement.getQuarter() }, this.formatFetchQuarter);
    } else if (type === 'range' && type !== this.state.typeRadios) {
      this.setState({
        typeRadios: type, fromDate: new Date('2017-08-18T00:00:00-0700'), toDate: new Date(),
      }, () => {
        this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, this.state.fromDate, this.state.toDate, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection);
      });
    }
  }

  setToDate = (e) => {
    if (e < this.state.fromDate) {
      return;
    }
    this.setState(
      { toDate: e },
      () => { this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, this.state.fromDate, e, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection); },
    );
  }

  setFromDate = (e) => {
    if (e > this.state.toDate) {
      return;
    }
    this.setState(
      { fromDate: e },
      () => {
        this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, e, this.state.toDate, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection);
        },
    );
  }

  formatFetchMonth = () => {
    const {
      year, month, typeRadios,
    } = this.state;
    let FromDate = moment([year, month - 1]);
    let ToDate = moment(FromDate).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => {
      this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, FromDate, ToDate, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection);
    });
  }

  formatFetchQuarter = () => {
    const {
      year, quarter, typeRadios,
    } = this.state;
    let FromDate = moment([year, (quarter - 1) * 3]);
    let ToDate = moment([year, (quarter * 3) - 1]).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => {
      this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, FromDate, ToDate, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection);
    });
  }

  setMonthSelected = (e) => {
    this.setState({ month: e.value }, this.formatFetchMonth);
  }

  setQuarterSelected = (e) => {
    this.setState({ quarter: e.value }, this.formatFetchQuarter);
  }

  setPaymentCutoffDate = (e) => {
    this.setState(
      { paymentCutoffDate: e },
      () => {
        this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, this.state.fromDate, this.state.toDate, e, this.state.sortColumn, this.state.sortDirection);
        },
    );
  }

  checkParam = () => {
    if (!this.state.salesId && !this.state.state && !this.state.customerName) {
      alert('Please fill in at least one of the options-seller,state,customer.');
      return false;
    }
    return true;
  }

  fetchCustomerBySales = (salesId, state, customerName, fromDate, endDate, paymentCutoffDate, sortColumn, sortDirection) => {
    if (!this.checkParam()) {
      return false;
    }
    const token = localStorage.getItem('token');
    const dates = toFromDates(-1, fromDate, endDate);
    const postingDateGT = `start_date=${dates.fromDate}`;
    const postingDateLT = `end_date=${dates.toDate}`;
    const SalesIdParams = `Sales_id=${salesId}`;
    const StateParams = `State=${state}`;
    const customerNameParams = `Customer_name=${customerName}`
    const sort = `order=${sortDirection === 'DESC' ? '-' : ''}${sortColumn || ''}`;
    const url = `${AR_REPORT_CUSTOMERS_URL}?${postingDateGT}&${postingDateLT}&cut_off_date=${getFromToDates(paymentCutoffDate).toDate}&${SalesIdParams}&${StateParams}&${customerNameParams}&${sort}`;
    axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${token}` },
    }).then(response => {
      this.setState({customers: response.data.customers});
    }, err => {
      if (err.status === 500 || err.status === 404) {
        alert(DEFAULT_ERROR);
      }
    });
  }
  renderDateSelector = () => {
    const yearOptions = this.getYearOptions();
    if (this.state.typeRadios === 'range') {
      return (
        <div>
          <div className="report-table-filters" id="print-by-sales-form-date-selector">
            <label className="from-label">
              <Translate value="from" />
            </label>
            {
              GenericDatePicker({
                setDate: this.setFromDate,
                selectedDate: this.state.fromDate,
                onChange: (e) => {
                  this.setFromDate(e);
                },
              })
            }
            <label className="to-label">
              <Translate value="to" />
            </label>
            {
              GenericDatePicker({
                setDate: this.setToDate,
                selectedDate: this.state.toDate,
                onChange: (e) => {
                  this.setToDate(e);
                },
              })
            }
          </div>
        </div>
      );
    } else if (this.state.typeRadios === 'month') {
      const monthOptions = this.getMonthOptions();
      return (
        <div>
          <div className="report-table-filters" id="print-by-sales-form-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: (e) => { this.setState({ year: e.value }); },
              })
            }
            {
              GenericSelection({
                translation: <Translate value="month" />,
                options: monthOptions,
                value: this.state.month,
                setSelected: this.setMonthSelected,
              })
            }
          </div>
        </div>
      );
    }
    const quarterOptions = this.getQuarterOptions();
    return (
      <div>
        <div className="report-table-filters" id="print-by-sales-form-date-selector">
          {
            GenericSelection({
              translation: <Translate value="year" />,
              options: yearOptions,
              value: this.state.year,
              setSelected: (e) => { this.setState({ year: e.value }); },
            })
          }
          {
            GenericSelection({
              translation: <Translate value="quarter" />,
              options: quarterOptions,
              value: this.state.quarter,
              setSelected: this.setQuarterSelected,
            })
          }
        </div>
      </div>
    );
  }

  getYearOptions = () => {
    const yearOptions = [];
    let year = (new Date().getFullYear() + 1);
    while (year > 2017) {
      year -= 1;
      yearOptions.push({ value: year, label: year });
    }
    return yearOptions;
  }

  getMonthOptions = () => {
    const { year } = this.state;
    const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthOptions = [];
    const currentyear = new Date().getFullYear();
    let month = 0;
    if (year) {
      if (year < currentyear) {
        month = 12;
      } else {
        month = new Date().getMonth() + 1;
      }
      for (let i = 1; i < month + 1; i += 1) {
        monthOptions.push({ value: i, label: dateMap[i - 1] });
      }
    }
    return monthOptions;
  }

  getQuarterOptions = () => {
    const { year } = this.state;
    const quarterOptions = [];
    const currentyear = new Date().getFullYear();
    let quarter = 0;
    if (year) {
      if (year < currentyear) {
        quarter = 4;
      } else {
        const month = new Date().getMonth() + 1;
        quarter = (Math.ceil(month / 3));
      }
    }
    for (let i = 1; i < quarter + 1; i += 1) {
      quarterOptions.push({ value: i, label: i });
    }
    return quarterOptions;
  }

  handleGridSort = (sortColumn, sortDirection) => {
    const column = sortDirection !== 'NONE' ? sortColumn : '';
    const direction = sortDirection !== 'NONE' ? sortDirection : '';
    const state = Object.assign({}, this.state, { sortColumn: column, sortDirection: direction });
    this.setState(state, () => {
      this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, this.state.FromDate, this.state.ToDate, this.state.paymentCutoffDate, column, direction);
    });
  }

  renderCustomersTable = () => {
    const columns = [
      {
        key: 'CustomerNum',
        name: <Translate value="customer_num" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'Email',
        name: <Translate value="email" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: 'FirstName',
        name: <Translate value="first_name" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'LastName',
        name: <Translate value="last_name" />,
        resizable: true,
        sortable: true,
        width: 90,
      },
      {
        key: 'Telephone',
        name: <Translate value="phone" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'City',
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: 'State',
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        width: 50,
      },
      {
        key: 'Street',
        name: <Translate value="street" />,
        resizable: true,
        sortable: true,
        width: 220,
      },
      {
        key: 'Zip',
        name: <Translate value="zip" />,
        resizable: true,
        sortable: true,
        width: 50,
      }
    ];
    return (
      <div id="CustomerStatementListTable-dataGrid1">
        <ReactDataGrid
          minHeight={400}
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          headerRowHeight={45}
          // minHeight={minHeight}
          rowGetter={(i) => this.state.customers[i]}
          rowsCount={this.state.customers.length}
        />
      </div>
    );
  }

  renderPrintBtn = () => {
    let { fromDate, toDate } = this.state;
    const dates = toFromDates(-1, fromDate, toDate);
    const paymentCutoffDate = getFromToDates(this.state.paymentCutoffDate).toDate;
    return <DropdownButton
      bsStyle="primary"
      disabled={!checkPermission('print_customer_statement')}
      title={<span>
                   <em className='fa fa-print' />
                   <Translate value="print_statements" />
                 </span>}
      noCaret
      id="dropdown-statement"
    >
      <MenuItem
        eventKey="1"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, false, this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="detailed_statement" />
      </MenuItem>
      <MenuItem
        eventKey="2"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, true, this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="simplified_statement" />
      </MenuItem>
      <MenuItem
        eventKey="3"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printPlainARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, 'print', this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="detailed_plain_statement" />
      </MenuItem>
      <MenuItem
        eventKey="4"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printPlainARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, 'simplified-print', this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="simplified_plain_statement" />
      </MenuItem>
      <MenuItem
        eventKey="5"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printPlainARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, 'monthly-print', this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="monthly_statement" />
      </MenuItem>
      <MenuItem
        eventKey="6"
        onSelect={() => {
          if (!this.checkParam()) {
            return false;
          }
          this.props.printPlainARReportBySales(this.state.salesId, this.state.state, dates.fromDate, dates.toDate, paymentCutoffDate, 'payment-term-print', this.state.sortColumn, this.state.sortDirection); }
        }
      ><Translate value="payment_term" />
      </MenuItem>
    </DropdownButton>
  }

  renderDateFilter = () => {
    return genericRadioFilter({
      content: [
        {
          option: 'range',
          id: 'dateRange-radio-filter',
          name: 'dateFilterRadios',
          labelName: 'date_range',
        },
        {
          option: 'quarter',
          id: 'quarter-radio-filter',
          name: 'dateFilterRadios',
          labelName: 'quarter',
        },
        {
          option: 'month',
          id: 'month-radio-filter',
          name: 'dateFilterRadios',
          labelName: 'month',
        },
      ],
      value: this.state.typeRadios,
      handleOnClick: this.handleDateFilterChange,
      type: 'buttons',
    })
  }
  render() {
    const Users = this.getUsers();
    return <div id="print-by-sales-form" style={{height: '95.5%'}}>
      <Panel id="date-range-picker" className='form-horizontal' style={{height: '95.5%'}}>
        <Row>
          <Col xs={3}>
            <div className="form-group">
              <label className="control-label"><Translate value="select_seller" /></label>
              <div className="control-dropdown">
                <Field name="Seller" component={Selection} options={Users} />
              </div>
            </div>
          </Col>
          <Col xs={1}>
            <div className="form-group" style={{marginLeft: '20px'}}>
              <label>
                <Translate value="state" />:
              </label>
              <Input
                type="text"
                name="state"
                value={this.state.state}
                onChange={(e) =>
                  this.setState({state: e.target.value})
                }
              />
            </div>
          </Col>
          <Col xs={4}>
            <div className="form-group" style={{marginLeft: '20px'}}>
              <label>
                <Translate value="customer_name" />:
              </label>
              <Input
                type="text"
                name="state"
                value={this.state.customerName}
                onChange={(e) =>
                  this.setState({customerName: e.target.value})
                }
              />
            </div>
          </Col>
          <Col xs={1}>
            <div className="form-group" style={{marginTop: '16px'}}>
              <Button
                className="search-button"
                bsStyle="primary"
                disabled={!this.state.salesId && !this.state.state && !this.state.customerName}
                onClick={() => {
                  this.fetchCustomerBySales(this.state.salesId, this.state.state, this.state.customerName, this.state.fromDate, this.state.toDate, this.state.paymentCutoffDate, this.state.sortColumn, this.state.sortDirection);
                }}
              >
                <em className="fa fa-search" />
              </Button>
            </div>
          </Col>
          <Col xs={2} className="print-by-sales-btn">
              {this.renderPrintBtn()}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <label>
              <Translate value="statement_range" /><span className="colon">:</span>
            </label>
            <div id="status-filter-radios">
              {this.renderDateFilter()}
            </div>
            {this.renderDateSelector()}
          </Col>
          <Col xs={6}>
            <Col id="status-filter-radios">
              <label>
                <Translate value="payment_cutoff_date" /><span className="colon">:</span>
              </label>
              <div>
                {
                  GenericDatePicker({
                    setDate: this.setPaymentCutoffDate,
                    selectedDate: this.state.paymentCutoffDate,
                  })
                }
              </div>
              <p style={{position: "relative", left: "5px", top: "3px"}}>(<Translate value="simplified_statement_only" />)</p>
            </Col>
          </Col>
        </Row>
        <Row>
          {this.renderCustomersTable()}
        </Row>
      </Panel>
    </div>
  }
}

const printBySalesModal = reduxForm({
  form: 'printBySales',
})(PrintBySalesModal);
const selector = formValueSelector('printBySales');
const mapStateToProps = state => {
  const Seller = selector(state, 'Seller');
  return {
    users: state.settings.all,
    Seller,
  }
}
export default connect(mapStateToProps, { fetchBaseUsers, printARReportBySales, printPlainARReportBySales })(printBySalesModal)



// WEBPACK FOOTER //
// ./master/jsx/components/AR/PrintBySalesModal.jsx